import { createAction, createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { IHowToImage } from "InterfacesTypes/interfaces";


export interface HowToImagesState {
    howToimages: IHowToImage[];
    loading: boolean;
    error: string | null;
};

const initialState: HowToImagesState = {
    howToimages: [],
    loading: false,
    error: null,
};

export const fetchHowToImages = createAction(
    "howToImages/fetchHowToImages"
);

export const howToImagesSlice = createSlice({
    name: "howToImages",
    initialState,
    reducers: {
        fetchStart(state) {
            state.loading = true;
            state.error = null;
        },
        fetchSuccess(state, action: PayloadAction<IHowToImage[]>) {
            state.loading = false;
            state.howToimages = action.payload;
        },
        fetchFailure(state, action: PayloadAction<string | null | undefined>) {
            state.loading = false;
            state.error = action.payload ?? "Något gick fel vid howToImages sagan.";
        },
        setHowToImages(
            state,
            action: PayloadAction<IHowToImage[]>
        ) {
            state.howToimages = action.payload;
        },
    },
});

export const {
    fetchStart,
    fetchSuccess,
    fetchFailure,
    setHowToImages,
} = howToImagesSlice.actions;

export const HowToImagesReducer = howToImagesSlice.reducer;